import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function deleteStaffAvailability(input: { id: number; availabilityId: number }) {
  const { id, availabilityId } = input
  return restApiClient
    .url(constructApiUrl(API.staffs.deleteAvailability.url, { id, availabilityId }))
    .delete()
}
